import React, { useState } from "react";
import { Modal, Text } from "@networkraildigitalfactory/components";
import useMyEmployees from "../../../hooks/useMyEmployees";
import styles from "./CascadingObjectives.module.css";
import useDisableScroll from "../../../hooks/useDisableScroll";

const CascadingObjectives = (props) => {
  const [isDisabled, setIsDisabled] = useState(false);
  const { show, close, confirm, getSelectedEmployees } = props;
  const myEmployees = useMyEmployees();
  const selectedEmployeesEmails = getSelectedEmployees();
  const getEmployeeNameFromEmail = (employeeEmail) => {
    const employee = myEmployees && myEmployees.filter((emp) => emp.email === employeeEmail);
    return employee[0].fullName;
  };
  useDisableScroll(show);

  return (
    <Modal
      type="confirm"
      cancelText="Back"
      cancelButtonColor="red"
      confirmText="Cascade objective"
      confirmButtonColor={isDisabled ? "grey" : "green"}
      show={show}
      onClose={close}
      confirmButtonDisabled={isDisabled}
      onConfirm={() => {
        setIsDisabled(true);
        confirm();
      }}
      style={{
        maxWidth: "90%",
        width: "690px",
        top: "5vh",
        position: "fixed",
        maxHeight: "90vh",
        overflowY: "auto",
      }}
    >
      <Text wrapper="h1" type="header">
        Confirm employees
      </Text>
      <Text wrapper="span" type="body">
        This objective will be cascaded to the following employees:
      </Text>
      <ul className={styles.employee_list}>
        {selectedEmployeesEmails &&
          selectedEmployeesEmails.map((employee, index) => {
            return (
              <li key={index}>
                <Text wrapper="span" type="body">
                  {show && getEmployeeNameFromEmail(employee)}
                </Text>
              </li>
            );
          })}
      </ul>
      <Text wrapper="span" type="body">
        Are you sure you wish to cascade this objective?
      </Text>
    </Modal>
  );
};
export default CascadingObjectives;
